/**
 * Footer Navigation.
 *
 * @format
 */

import React, { useContext } from 'react';
import { NavigationContext } from '@context/navigation-context';
import FooterLink from './footer-link';
import ContactForm from '@forms/form-types/contact-form';

interface DataTypes {
  name: string;
  link: string;
  new_window: string;
  children: Array<DataTypes> | null;
  tid: string;
}
interface FooterNavigationProps {
  type: string;
}

/**
 * Build Footer Menu.
 *
 * @param {object} data
 * @param {boolean} parent
 */
const buildFooterMenu = (apiData: Array<DataTypes>): JSX.Element[] | null => {
  if (apiData && apiData.length > 0) {
    return apiData.map((data: DataTypes) => {
      const { name, link, new_window: external, children, tid } = data;
      const submenu = children ? buildFooterMenu(children) : null;

      // Footer contact form link.
      if (tid === '22') {
        return (
          <li key={tid}>
            <ContactForm
              region="footer"
              formType="standard"
              linkText="Contact Us"
              linkType="button"
            />
          </li>
        );
      }

      // Standard footer link.
      return (
        <FooterLink
          name={name}
          external={external}
          link={link}
          submenu={submenu}
          key={tid}
        />
      );
    });
  }
  return null;
};

/**
 * Footer Navigation.
 */
const FooterNavigation = ({ type }: FooterNavigationProps): JSX.Element => {
  const navigationData = useContext(NavigationContext);
  const {
    footer_menu_vocab: mainNavigation,
    company_info_menu_vocab: contactLinks,
    legal_menu_vocab: legalLinks,
  } = navigationData;

  let data = null;
  switch (type) {
    case 'footer-nav':
      data = mainNavigation;
      break;
    case 'contact-info-nav':
      data = contactLinks;
      break;
    case 'legal-links':
      data = legalLinks;
      break;
    default:
      data = null;
  }

  const menu: JSX.Element | null = data ? buildFooterMenu(data) : null;

  if (type === 'legal-links') {
    return (
      <div className="legal-navigation">
        <div className="container">
          <nav role="navigation" className={type}>
            <ul>{menu}</ul>
          </nav>
        </div>
      </div>
    );
  }

  return (
    <nav role="navigation" className={type}>
      <ul>{menu}</ul>
    </nav>
  );
};
export default FooterNavigation;
